import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { jaffreyConfig } from "./data";

export default function JaffreyPage() {
  return <CityPageTemplate config={jaffreyConfig} />;
}